import { Badge as ShadcnBadge, BadgeProps as ShadcnBadgeProps, Tooltip } from "@altimateai/lego";
import { ReactNode } from "react";

interface Props extends ShadcnBadgeProps {
  tooltip?: string | ReactNode;
  color?: "primary" | "danger" | "warning" | "success" | "info";
  pill?: boolean;
  label?: string;
}

const Badge = ({ tooltip, color, ...props }: Props) => {
  // Map reactstrap color props to shadcn variant props
  const getVariant = () => {
    switch (color) {
      case "primary":
        return "default";
      case "danger":
        return "destructive";
      case "warning":
        return "warning";
      case "success":
        return "success";
      case "info":
        return "secondary";
      default:
        return "default";
    }
  };

  const badgeElement = <ShadcnBadge variant={getVariant()} {...props} />;

  if (tooltip) {
    return <Tooltip title={tooltip}>{badgeElement}</Tooltip>;
  }

  return badgeElement;
};

export default Badge;
